// Portal user tier helpers — kept in one place so all pages agree on the
// set of "client-side" roles (legacy `client` + the 3 new sub-tiers).
export const CLIENT_TIER_ROLES = ["client", "client_admin", "regional_manager", "site_manager"];

export function isClientTier(user) {
  return CLIENT_TIER_ROLES.includes(user?.role);
}

// Human-readable role labels used across dropdowns / tables / audit views.
export const ROLE_LABELS = {
  super_admin: "Super Admin",
  admin: "Admin",
  chief_security_officer: "Chief Security Officer",
  operations_manager: "Operations Manager",
  supervisor: "Supervisor",
  dispatcher: "Dispatcher",
  guard: "Officer",
  client: "Client (legacy)",
  client_admin: "Client Admin",
  regional_manager: "Regional Manager",
  site_manager: "Site Manager",
};

export function roleLabel(role) {
  return ROLE_LABELS[role] || role || "—";
}

/**
 * Role → hex accent color. Used for the small colored dot on the "Recent
 * workspaces" pill row (Login page) and anywhere else a compact
 * role-at-a-glance visual helps. Keep values aligned with the palette
 * already used across the app (system-red, amber, blue, green, purple).
 *
 * Buckets:
 *   red    — command tier (super_admin, admin)
 *   amber  — operations tier (CSO, OM, supervisor)
 *   blue   — field / real-time (dispatcher, guard)
 *   purple — client-side leaders (client_admin, regional_manager, site_manager)
 *   green  — legacy 'client'
 *   zinc   — anything unrecognised
 */
const ROLE_ACCENT_COLORS = {
  super_admin: "#FF3B30",
  admin: "#FF3B30",
  chief_security_officer: "#FF9F0A",
  operations_manager: "#FF9F0A",
  supervisor: "#FF9F0A",
  dispatcher: "#0A84FF",
  guard: "#0A84FF",
  client_admin: "#BF5AF2",
  regional_manager: "#BF5AF2",
  site_manager: "#BF5AF2",
  client: "#34C759",
};

export function roleAccentColor(role) {
  return ROLE_ACCENT_COLORS[role] || "#71717A";
}
